export const fiatBrands = [
  'mifinity',
  'mastercard',
  'muchbetter',
  'flexepin',
  'Ecopayz',
  'Maestro',
  'Neteller',
  'Instadebit',
  'visa',
  'jeton',
  'astropay',
  'neosurf',
  'iDebit',
  'Vernus',
  'Transfer',
  'mastercard',
  'mifinity',
  'maestro',
  'interac online',
  'piastrix',
];

export const brandSizeMap = {
  interac: { width: 80, height: 40 },
  skrill: { width: 82, height: 25 },
  usdt: { width: 92, height: 40 },
  bitcoinCash: { width: 92, height: 40 },
  crypto: { width: 82, height: 20 },
  fiat: { width: 112, height: 40 },
  sol: { width: 112, height: 40 },
  trx: { width: 112, height: 40 },
  xrp: { width: 92, height: 35 },
};

export const getBrandKey = (brand: string): keyof typeof brandSizeMap => {
  const lower = brand.toLowerCase();
  if (fiatBrands.some((f) => lower.includes(f))) return 'fiat';
  if (lower.includes('interac')) return 'interac';
  if (lower.includes('usdt')) return 'usdt';
  if (lower.includes('bch')) return 'bitcoinCash';
  if (lower.includes('skrill')) return 'skrill';
  if (lower.includes('sol')) return 'sol'; // SOLANA
  if (lower.includes('trx')) return 'trx'; // TRON
  if (lower.includes('xrp')) return 'xrp'; // RIPPLE
  if (lower.includes('coinspaid') || lower.includes('cpp')) return 'crypto';
  return 'fiat';
};
